
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class BankPaymentForm extends Vue {
  paymentRedirectUrl: string | undefined = process.env.VUE_APP_PAYMENT_REDIRECT;
  websiteUrl: string | undefined = process.env.VUE_APP_BANK_URL;
}
